import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

import {THEME} from '@/site/constants';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {light: THEME},
    options: {
      customProperties: true,
    },
  },
});
